import controller from './new-user-flow.controller';

const template = require('./new-user-flow.html');

export default {
    controller,
    template
};
